/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Reopen_After_RoundInputs */



/**
* | output |
* | --- |
* | "Registration cannot reopen once a round has been played" |
*
* @param {Err_Tournament_Reopen_After_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_reopen_after_round = /** @type {((inputs?: Err_Tournament_Reopen_After_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Reopen_After_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les inscriptions ne peuvent pas rouvrir une fois une ronde jouée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las inscripciones no pueden reabrirse una vez jugada una ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As inscrições não podem reabrir depois de uma rodada jogada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le iscrizioni non possono riaprire dopo che è stato giocato un round")
	return /** @type {LocalizedString} */ ("Registration cannot reopen once a round has been played")
});